import { render, staticRenderFns } from "./LowerDashboard.vue?vue&type=template&id=39db337a&"
import script from "./LowerDashboard.vue?vue&type=script&lang=js&"
export * from "./LowerDashboard.vue?vue&type=script&lang=js&"
import style0 from "./LowerDashboard.vue?vue&type=style&index=0&id=39db337a&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports